import TaskOutlined from "@mui/icons-material/TaskOutlined";
import { Box, Skeleton, Typography } from "@mui/material";
import { usePendingReviewCount } from "../../../pages/reviews/hooks/use-pending-review-count";
import { useFlag } from "../../../server/optimizely";

import type { FC } from "react";

/**
 * Communications awaiting the user's approval, as the sidebar's Approvals badge counts them. Hidden
 * unless approvals are switched on, and if the reviews fail to load.
 */
export const PendingApprovalsCount: FC = () => {
  const [reviewEnabled] = useFlag("reviewer_role");
  const { data, loading, error } = usePendingReviewCount(reviewEnabled);

  if (!reviewEnabled || error) return null;

  return (
    <Box display="flex" alignItems="center" gap={0.5} title="Communications awaiting your approval">
      <TaskOutlined fontSize="small" />
      {loading || data === null ? (
        <Skeleton variant="text" width={40} />
      ) : (
        <Typography variant="body2">{data} new</Typography>
      )}
    </Box>
  );
};
